module.exports = __webpack_public_path__ + "static/media/image_01.9f1d982e.png";